import { useEffect, useState } from "react";
import Profile from "../../Components/Profile";
import Loader from "../../loader";

const ProfilePage = () => {
  return (
    <>
      <Profile />
    </>
  );
};
export default ProfilePage;
